import { createLogger } from "logging";
import { LogLevel } from "models/LogLevel";
import { TranslationLabels } from "translations/TranslationLabels";

const logger = createLogger("TranslationsProvider");

export function getResource(
  key: string,
  defaultValue: string | null = null,
  logWarning = true,
  labelsOverride: TranslationLabels | undefined = undefined
): string {
  const keyLowerCase = key.toLowerCase();
  const defaultValueToUse = defaultValue === null ? `$Resources:${key}` : defaultValue;

  const labelsToUse = labelsOverride ?? window.labels ?? {};
  const entries = Object.entries(labelsToUse);
  const matches = entries.filter((x) => x[0].toLowerCase() == keyLowerCase);
  if (!matches.length) {
    const logLevel: LogLevel = logWarning ? LogLevel.Warn : LogLevel.Trace;
    logger.log(logLevel, `getResource(): key:='${key}' does not exist!`);
    return defaultValueToUse;
  }

  const value = `${matches[0][1]}`;
  if (!value.length) {
    const logLevel: LogLevel = logWarning ? LogLevel.Warn : LogLevel.Trace;
    logger.log(logLevel, `getResource(): key:='${key}' value is empty!`);
    return defaultValueToUse;
  }

  return value;
}

declare global {
  interface Window {
    labels: TranslationLabels;
  }
}
